import { Form, Formik } from "formik"
import { ImportUsersFormContent } from "./ImportUsersFormContent"
import { ImportUsersFormValues, UpdateKeyListUsers, UserGroup } from "../importUsersTypes"
import { ImportCsvFile } from "../../../../../../shared/components/importCsv/importCsvFileTypes"

type ImportUsersFormProps = Readonly<{
    onSubmit: (importData: ImportCsvFile) => void
}>

export const ImportUsersForm = ({ onSubmit }: ImportUsersFormProps) => {
    const defaultInitialValues = {
        userGroupId: UserGroup.FROM_FILE,
        updateKey: UpdateKeyListUsers.EMAIL,
        updateMatching: false,
        deleteUnmatched: false,
        file: null,
    }

    function handleSubmit({ file, updateMatching, deleteUnmatched, updateKey }: ImportUsersFormValues) {
        file && onSubmit({ file, updateMatching, deleteUnmatched, updateKey })
    }

    return (
        <>
            <Formik<ImportUsersFormValues>
                enableReinitialize
                initialValues={defaultInitialValues}
                onSubmit={handleSubmit}
            >
                <Form>
                    <ImportUsersFormContent />
                </Form>
            </Formik>
        </>
    )
}
